import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';

interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: Array<KeyConcept>;
    subtopics: Array<Topic>;
    sources: Array<any>;
    sourceParams: SourceParams;
    sourcesSubTopic: SourcesSubTopic;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    skipRelevance: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
    // children: Array<Topic>;
}

interface KeyConcept {
    name: string;
    isSearch: boolean;
    isRelevance: boolean;
}

interface SourceParams {
    [key: string]: any;
}

interface SourcesSubTopic {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    includeSubTopic: { [key: string]: boolean };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
}

// This decorator is what makes this class an Angular component.
@Component({
    selector: 'app-topic-form',
    templateUrl: './topic-form.component.html',
    styleUrls: ['./topic-form.component.scss'],
})
export class TopicFormComponent implements OnInit {
    topic: Topic = this.createInitialTopic();
    private articleCountButtonClicked: Subscription;
    buttonClicked = false;
    articleCountValue = false;
    getTemplateSubs: Subscription;
    confirmgyanFlag: Subscription;
    constructor(
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private submitGyanService: SubmitgyanService,
    ) {
        this.getTemplateSubs = this.commonServiceService.templateDataSubject$.subscribe((dataItem: any) => {
            console.log('dataItem is', dataItem);
            if (dataItem?.topicOutline) {
                this.topic = dataItem.topicOutline;
                this.addLevelAttribute(this.topic); // adding level so it will converted to hierarchical view
                const sources = dataItem.sources;
                const config = dataItem.config;

                this.commonServiceService.setTemplateDataSubjectForSources(sources);
                this.commonServiceService.setTemplateDataSubjectForTopicOutline(this.topic);
                this.commonServiceService.setTemplateDataSubjectForConfig(config);
                this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
                dataItem?.isDraft ? this.commonServiceService.setTemplatetLoaded(false) : this.commonServiceService.setTemplatetLoaded(true);
                this.saveToLocalStorage();
            } else {
                if (typeof dataItem == 'number' && dataItem !== null) {
                    this.submitGyanService.getGyanTemplate(dataItem).subscribe((response) => {
                        const myJSON = JSON.stringify(response);
                        this.topic = JSON.parse(myJSON).topicOutline;
                        console.log('----this.topic', JSON.parse(myJSON));
                        this.addLevelAttribute(this.topic); // adding level so it will converted to hierarchical view
                        const sources = JSON.parse(myJSON).sources;
                        const config = JSON.parse(myJSON).config;
                        //sending sources from subject
                        this.commonServiceService.setTemplateDataSubjectForSources(sources);
                        this.commonServiceService.setTemplateDataSubjectForTopicOutline(this.topic);
                        this.commonServiceService.setTemplateDataSubjectForConfig(config);
                        this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
                        this.commonServiceService.setTemplatetLoaded(true);
                        //this.cd.detectChanges();
                        //   localStorage.setItem('topicOutline', JSON.parse(myJSON).topicOutline);
                    });
                }
            }
        });

        this.confirmgyanFlag = this.commonServiceService.confirmGyan$.subscribe((data: any) => {
            if (data) {
                const storedData = this.localStorageService.getItem('topicOutline');
                this.topic = storedData;
                this.commonServiceService.setTemplatetLoaded(true);
                this.commonServiceService.setTopicName(this.topic?.name);
            }
        });

        this.articleCountButtonClicked = this.commonServiceService.articleCountButtonClicked$.subscribe((value) => {
            this.buttonClicked = value?.buttonCLick;
            this.articleCountValue = value?.articleCountValue;
        });

        // this.commonServiceService.loadFromLocal$.subscribe(() => {
        //     console.log('Reload triggered for topic form');
        //     this.loadFromLocalStorage(); // Re-run the initialization logic
        //   });
    }

    addLevelAttribute(topic: Topic, currentLevel: number = 0): void {
        //for root level
        topic.level = currentLevel;
        topic.ParentValueChanged = true;
        // if there are subtopics, recursively assign levels to them
        if (topic.subtopics && topic.subtopics.length > 0) {
            topic.subtopics.forEach((subtopic) => this.addLevelAttribute(subtopic, currentLevel + 1));
        }
    }

    createInitialTopic(): Topic {
        return {
            name: '',
            id: Date.now(),
            isOrganisationalLabel: false,
            isArticleCountToZero: false,
            keyConcept: [],
            subtopics: [],
            sources: [],
            sourceParams: {},
            sourcesSubTopic: {
                repoIds: {},
                repoAvailable: true,
                knowledgeStoreIds: {},
                includeSubTopic: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
            },
            exportDocumentRules: null,
            parentSearchContextList: [],
            parentRelContextList: [],
            globalRelevance: true,
            processNonArticles: false,
            skipRelevance: false,
            suppressSummary: false,
            suppressMDS: false,
            ignoreProcess: false,
            dor: null,
            intentScore: null,
            level: 0,
            showAddIcon: false,
            ParentList: [],
            ParentValueChanged: false,
            isTemplate: false,
        };
    }

    ngOnInit(): void {
        console.log('ngOnInitcalled for topic form');
        if (this.topic == null) {
            this.topic = this.createInitialTopic();
        }
        const gyanData = this.localStorageService.getItem('gyanData');
        if (gyanData?.gyanName) {
            this.topic.name = gyanData.gyanName;
            this.saveToLocalStorage();
            this.commonServiceService.setTopicName(gyanData.gyanName);
        } else {
            this.commonServiceService.setTopicName('');
        }
        const storedData = localStorage.getItem('topicOutline');
        if (storedData) {
            //this.topic = JSON.parse(storedData);
        }
        this.commonServiceService.setTopicName(this.topic.name);
    }

    // loadFromLocalStorage(){

    //     // const storedData = localStorage.getItem('topicOutline');
    //     // if (storedData) {
    //     //     this.topic = JSON.parse(storedData);
    //     // }
    // }

    saveToLocalStorage(): void {
        //debugger;
        console.log('the final local storage is', this.topic);
        console.log('this.topic.subtopics. ', this.topic.subtopics.length);

        if (this.topic.subtopics.length === 0) {
            // if (this.buttonClicked) this.topic.isArticleCountToZero = this.articleCountValue;
            if (!this.topic.ParentValueChanged) this.topic.isArticleCountToZero = false;
        } else {
            //console.log("else part for saveTOLocalStorage");
            //found subtopics
            // if (this.topic.isOrganisationalLabel === true) this.topic.isArticleCountToZero = false;
            // else {
            //     if (this.buttonClicked) this.topic.isArticleCountToZero = this.articleCountValue;
            //     else this.topic.isArticleCountToZero = true;
            // }
            if (!this.topic.ParentValueChanged) this.topic.isArticleCountToZero = true;
        }

        // console.log(this.topic.isArticleCountToZero);
        localStorage.setItem('topicOutline', JSON.stringify(this.topic));
    }

    saveToLocalStorageKeyConcepts(event: { topicId: number; keyConcepts: Array<KeyConcept> }): void {
        console.log(event);
        console.log('-----------', this.topic);
        console.log('-----------', event.topicId);
        console.log('-----------', event.keyConcepts);
        if (this.topic.id === event.topicId) {
            // If the root topic matches, update its key concepts
            this.topic.keyConcept = event.keyConcepts;
        } else {
            // If the root doesn't match, check subtopics recursively
            const topic = this.findTopicById(event.topicId, this.topic.subtopics);
            if (topic) {
                topic.keyConcept = event.keyConcepts;
            }
        }
        this.saveToLocalStorage();
    }

    saveToLocalStorageSubTopicSources(event: { topicId: number; topic: Topic }): void {
        console.log(event);
        console.log('-----------', this.topic);
        console.log('-----------', event.topicId);
        console.log('-----------', event.topic);
        if (this.topic.id === event.topicId) {
            // If the root topic matches, update its key concepts
            this.topic = event.topic;
        } else {
            // If the root doesn't match, check subtopics recursively
            const topic = this.findTopicById(event.topicId, this.topic.subtopics);
            if (topic) {
                topic.sourceParams = event.topic.sourceParams;
                topic.sourcesSubTopic.favouriteWebsites = event.topic.sourcesSubTopic.favouriteWebsites;
                topic.sourcesSubTopic.knowledgeStoreIds = event.topic.sourcesSubTopic.knowledgeStoreIds;
                topic.sourcesSubTopic.repoIds = event.topic.sourcesSubTopic.repoIds;
                topic.sourcesSubTopic.includeSubTopic = event.topic.sourcesSubTopic.includeSubTopic;
            }
        }
        this.saveToLocalStorage();
    }

    findTopicById(topicId: number, topics: Array<Topic>): Topic | undefined {
        for (const topic of topics) {
            if (topic.id === topicId) {
                return topic;
            }
            const subtopic = this.findTopicById(topicId, topic.subtopics);
            if (subtopic) {
                return subtopic;
            }
        }
        return undefined;
    }

    /* eslint-disable sonarjs/cognitive-complexity */
    saveToLocalStorageTemplates(event: { topicId: number; topics: any }): void {
        console.log(event);
        console.log('-----------', this.topic);
        console.log('-----------', event.topicId);
        console.log('-----------', event.topics);
        if (this.topic.id === event.topicId) {
            // If the root topic matches, update its key concepts
            this.topic.subtopics = [...event.topics.subtopics, ...this.topic.subtopics];
            this.topic.isOrganisationalLabel = event.topics.isOrganisationalLabel || false;
            this.topic.isArticleCountToZero = event.topics.isArticleCountToZero || false;
            this.topic.keyConcept =
                event.topics.keyWords?.map((kw: any) => ({
                    name: kw.keywords,
                    isSearch: kw.isForSearch || false,
                    isRelevance: kw.isForRelevance || false,
                })) || [];
            this.topic.sources = event.topics.sources || [];
            this.topic.sourceParams = event.topics.sourceParams || {};
            this.topic.sourcesSubTopic = {
                repoIds: event.topics.sourcesSubTopic?.repoIds || {},
                repoAvailable: event.topics.sourcesSubTopic?.repoAvailable || true,
                knowledgeStoreIds: event.topics.sourcesSubTopic?.knowledgeStoreIds || {},
                includeSubTopic: event.topics.sourcesSubTopic?.includeSubTopic || {},
                webAvailable: event.topics.sourcesSubTopic?.webAvailable || false,
                favouriteWebsites: event.topics.sourcesSubTopic?.favouriteWebsites || [],
                dispreferredWebsites: event.topics.sourcesSubTopic?.dispreferredWebsites || [],
            };
            this.topic.exportDocumentRules = event.topics.exportDocumentRules || null;
            this.topic.parentSearchContextList = event.topics.parentSearchContextList || [];
            this.topic.parentRelContextList = event.topics.parentRelContextList || [];
            this.topic.globalRelevance = event.topics.globalRelevance || false;
            this.topic.processNonArticles = event.topics.processNonArticles || false;
            this.topic.suppressSummary = event.topics.suppressSummary || false;
            this.topic.suppressMDS = event.topics.suppressMDS || false;
            this.topic.ignoreProcess = event.topics.ignoreProcess || false;
            this.topic.dor = event.topics.dor || null;
            this.topic.intentScore = event.topics.intentScore || null;
            this.topic.level = this.topic.level;
            this.topic.showAddIcon = false;
            this.topic.isTemplate = true;
            this.topic.ParentValueChanged = true;
        } else {
            // If the root doesn't match, check subtopics recursively
            const topic = this.findTopicById(event.topicId, this.topic.subtopics);
            if (topic) {
                console.log('...............', event.topics.parentRelContextList);
                topic.subtopics = [...event.topics.subtopics, ...topic.subtopics];
                topic.isOrganisationalLabel = event.topics.isOrganisationalLabel || false;
                topic.isArticleCountToZero = event.topics.isArticleCountToZero || false;
                topic.keyConcept =
                    event.topics.keyWords?.map((kw: any) => ({
                        name: kw.keywords,
                        isSearch: kw.isForSearch || false,
                        isRelevance: kw.isForRelevance || false,
                    })) || [];
                topic.sources = event.topics.sources || [];
                topic.sourceParams = event.topics.sourceParams || {};
                topic.sourcesSubTopic = {
                    repoIds: event.topics.sourcesSubTopic?.repoIds || {},
                    repoAvailable: event.topics.sourcesSubTopic?.repoAvailable || true,
                    knowledgeStoreIds: event.topics.sourcesSubTopic?.knowledgeStoreIds || {},
                    includeSubTopic: event.topics.sourcesSubTopic?.includeSubTopic || {},
                    webAvailable: event.topics.sourcesSubTopic?.webAvailable || false,
                    favouriteWebsites: event.topics.sourcesSubTopic?.favouriteWebsites || [],
                    dispreferredWebsites: event.topics.sourcesSubTopic?.dispreferredWebsites || [],
                };
                topic.exportDocumentRules = event.topics.exportDocumentRules || null;
                topic.parentSearchContextList = event.topics.parentSearchContextList || [];
                topic.parentRelContextList = event.topics.parentRelContextList || [];
                topic.globalRelevance = event.topics.globalRelevance || false;
                topic.processNonArticles = event.topics.processNonArticles || false;
                topic.suppressSummary = event.topics.suppressSummary || false;
                topic.suppressMDS = event.topics.suppressMDS || false;
                topic.ignoreProcess = event.topics.ignoreProcess || false;
                topic.dor = event.topics.dor || null;
                topic.intentScore = event.topics.intentScore || null;
                topic.level = topic.level;
                topic.showAddIcon = false;
                topic.isTemplate = true;
            }
        }
        this.saveToLocalStorage();
    }

    saveToLocalStorageSettings(event: { topicId: number; settings: any }): void {
        // console.log("settings",event.settings);
        const updatedActual = this.UpdateData(this.topic, JSON.parse(JSON.stringify(event.settings)));
        // this.topic = this.mergeIncomingToTotal(JSON.parse(JSON.stringify(event.settings)), this.topic);
        console.log('the final value this.topic', updatedActual);
        this.saveToLocalStorage();
    }

    UpdateData(actual: any, latest: any) {
        //console.log("actual",actual);
        //console.log("latest",latest);
        if (actual.id === latest.id) {
            actual.name = latest.name;
            actual.isOrganisationalLabel = latest.isOrganisationalLabel;
            actual.isArticleCountToZero = latest.isArticleCountToZero;
            actual.keyConcept = latest.keyConcept || [];
            actual.sources = latest.sources || [];
            actual.sourceParams = latest.sourceParams || {};
            actual.sourcesSubTopic = latest.sourcesSubTopic || {};
            actual.exportDocumentRules = latest.exportDocumentRules || null;

            // Overwrite list properties with the latest values
            actual.parentSearchContextList = latest.parentSearchContextList || [];
            actual.parentRelContextList = latest.parentRelContextList || [];
            actual.ParentList = latest.ParentList || [];
            actual.ParentValueChanged = latest.ParentValueChanged;
            actual.isTemplate = latest.isTemplate || false;
            actual.globalRelevance = latest.globalRelevance;
            actual.processNonArticles = latest.processNonArticles;
            actual.skipRelevance = latest.skipRelevance;
            actual.suppressSummary = latest.suppressSummary;
            actual.suppressMDS = latest.suppressMDS;
            actual.ignoreProcess = latest.ignoreProcess;
            actual.dor = latest.dor || null;
            actual.intentScore = latest.intentScore || null;
            actual.level = latest.level;
            actual.showAddIcon = latest.showAddIcon;
            //    debugger;
            // Recursively update subtopics, ensuring lists are copied at every level
            if (actual.subtopics && Array.isArray(actual.subtopics)) {
                actual.subtopics.forEach((subtopic: { id: any }) => {
                    const latestSubtopic = latest.subtopics?.find((st: { id: any }) => st.id === subtopic.id);
                    if (latestSubtopic) {
                        this.UpdateData(subtopic, latestSubtopic);
                    } else {
                        latest.subtopics?.forEach((st: { subtopics: string | any; id: any }) => {
                            if (st.subtopics?.length) {
                                this.UpdateData(subtopic, st); // recursive update at deeper levels
                            }
                        });
                    }
                });
            }
        } else {
            this.saveSubtopicsSettings(this.topic, latest);
        }

        return actual;
    }

    saveSubtopicsSettings(element: any, settings: any) {
        if (element.subtopics != null && element.subtopics.length > 0) {
            console.log('coming inside the settings has child');
            element.subtopics.forEach((element2: any) => {
                console.log('coming inside the settings element2 are', element2);
                if (element2.id === settings.id) {
                    element2.name = settings.name;
                    element2.isOrganisationalLabel = settings.isOrganisationalLabel;
                    element2.isArticleCountToZero = settings.isArticleCountToZero;
                    element2.keyConcept = settings.keyConcept || [];
                    element2.sources = settings.sources || [];
                    element2.sourceParams = settings.sourceParams || {};
                    element2.sourcesSubTopic = settings.sourcesSubTopic || {};
                    element2.exportDocumentRules = settings.exportDocumentRules || null;

                    // Overwrite list properties with the latest values
                    element2.parentSearchContextList = settings.parentSearchContextList || [];
                    element2.parentRelContextList = settings.parentRelContextList || [];
                    element2.ParentList = settings.ParentList || [];
                    element2.ParentValueChanged = settings.ParentValueChanged;
                    element2.isTemplate = settings.isTemplate || false;
                    element2.globalRelevance = settings.globalRelevance;
                    element2.processNonArticles = settings.processNonArticles;
                    element2.skipRelevance = settings.skipRelevance;
                    element2.suppressSummary = settings.suppressSummary;
                    element2.suppressMDS = settings.suppressMDS;
                    element2.ignoreProcess = settings.ignoreProcess;
                    element2.dor = settings.dor || null;
                    element2.intentScore = settings.intentScore || null;
                    element2.level = settings.level;
                    element2.showAddIcon = settings.showAddIcon;
                    if (element2.subtopics && Array.isArray(settings.subtopics)) {
                        element2.subtopics.forEach((subtopic: { id: any }) => {
                            const latestSubtopic = settings.subtopics?.find((st: { id: any }) => st.id === subtopic.id);
                            if (latestSubtopic) {
                                this.UpdateData(subtopic, latestSubtopic);
                            } else {
                                settings.subtopics?.forEach((st: { subtopics: string | any; id: any }) => {
                                    if (st.subtopics?.length) {
                                        this.UpdateData(subtopic, st); // recursive update at deeper levels
                                    }
                                });
                            }
                        });
                    }
                } else {
                    this.saveSubtopicsSettings(element2, settings);
                }
            });
        }
    }

    ngOnDestroy() {
        this.articleCountButtonClicked.unsubscribe();
        this.getTemplateSubs.unsubscribe();
        this.confirmgyanFlag.unsubscribe();
    }
}
